import * as types from '../constants/actionsTypes';

const initialState = {
	actual: [],
	finished: [],
	loading: false,
	updating: false,
	activeItemId: null,
	error: null
}

export default function (state = initialState, action) {
	switch(action.type) {
		case types.LOAD_TASKS_ACTUAL_REQUEST:
		case types.LOAD_TASKS_FINISHED_REQUEST:
		case types.ADD_TASK_REQUEST:
		case types.REMOVE_TASK_REQUEST:
			return {
				...state,
				loading: true
			}

		case types.LOAD_TASKS_ACTUAL_FAILURE:
		case types.LOAD_TASKS_FINISHED_FAILURE:
		case types.ADD_TASK_FAILURE:
		case types.REMOVE_TASK_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error
			}

		case types.LOAD_TASKS_FINISHED_SUCCESS:
			return {
				...state,
				loading: false,
				finished: action.data.tasks
			}

		case types.LOAD_TASKS_ACTUAL_SUCCESS:
		case types.ADD_TASK_SUCCESS:
		case types.REMOVE_TASK_SUCCESS:
			return {
				...state,
				loading: false,
				actual: action.data.tasks
			}

		case types.UPDATE_TASK_REQUEST:
			return {
				...state,
				updating: true,
				activeItemId: action.extraField
			}

		case types.UPDATE_TASK_FAILURE:
			return {
				...state,
				updating: false,
				activeItemId: null
			}

		case types.UPDATE_TASK_SUCCESS:
			return {
				...state,
				updating: false,
				actual: action.data.tasks,
				activeItemId: null
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./reducers/tasks.js